module.exports = __webpack_public_path__ + "static/media/menu.37b1a497.svg";